import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, message, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { queryKeys } from '../../services/react-query/queryKeys';
import StatusTag from '../../hooks/StatusHook';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { PlusOutlined } from '@ant-design/icons';
import {
  deleteInsuranceClaim,
  getInsuranceClaim,
} from '../../network/InsuranceClaim';

const InsuranceClaim = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getInsuranceClaim],
    queryFn: () => getInsuranceClaim(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteInsuranceClaim(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message);
          return false;
        }
        client.invalidateQueries({
          queryKey: [queryKeys.getInsuranceClaim],
        });
        message.success('Deleted successfully');
        // message.success('تم الحذف بنجاح');
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: t.Patient,
      dataIndex: 'patient',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return String(record.patient)
          .toLowerCase()
          .includes(value.toLowerCase());
      },
    },
    {
      title: t.insurancePlan,
      dataIndex: 'insurance_plan',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.InsuranceClaimAmount,
      dataIndex: 'insurance_claim_amount',
    },
    {
      title: t.InsurancePayor,
      dataIndex: 'insurance_payor',
    },
    {
      title: t.status,
      dataIndex: 'status',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 150,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/insurance_claim/${record?.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title="Delete the Insurance Claim?"
              description="Are you sure to delete?"
              onConfirm={() => handleRemove.mutate(record?.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable =
    data?.data?.map((item, index) => ({
      key: index,
      ...item,
    })) || [];
  return (
    <div className="insurance-claim">
      <Heading
        title={t.Insurances}
        subTitle={t.InsuranceClaim}
        path="/insurance_claim"
      />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        // titleBtn={t.addEligibilityPlan}
        Placeholder={t.searchPatient}
        // pathBtn="/add-patient"
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              navigate('/insurance_claim/add');
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />
            {t.addInsuranceClaim}
          </Button>
        }
      />
    </div>
  );
};

export default InsuranceClaim;
